export const paths = {
  home: "/",
  careers: "/careers",
  contact: "/contact",
}
